import {
  BannersActionType,
  HIDE_ALLOW_LIST_OVERRIDE_WARNING,
  HIDE_BLOCKED_LIMIT_WARNING,
  HIDE_ROAMING_LIMIT_INFO,
  HIDE_PROFILE_LIMIT_WARNING,
} from "./banners.types";

export const hideRoamingLimitInfo = (): BannersActionType => ({
  type: HIDE_ROAMING_LIMIT_INFO,
});

export const hideAllowListOverrideWarning = (): BannersActionType => ({
  type: HIDE_ALLOW_LIST_OVERRIDE_WARNING,
});

export const hideBlockedLimitWarning = (): BannersActionType => ({
  type: HIDE_BLOCKED_LIMIT_WARNING,
});

export const hideProfileLimitWarning = (
  profileId: string
): BannersActionType => ({
  type: HIDE_PROFILE_LIMIT_WARNING,
  payload: profileId,
});
